
/**
 * 自动导入.vue文件作为全局组件
 */
export default  (Vue)=>{
    // https://webpack.docschina.org/guides/dependency-management/#requirecontext
    // 文件夹路径是否包含子目录
    let context = require.context("./comnt",true,/\.vue$/)
    context.keys().forEach(fileName => {
        let fileNameStr = fileName.replace(/\.\/(.+)\.vue/,'$1')

        if(fileNameStr.includes("/")){
            let arr = fileNameStr.split("/")
            fileNameStr = arr[arr.length - 1]
        }

        Vue.component("zp-"+fileNameStr,context(fileName).default)
    });

}